import { render } from "./ScrollingPage.vue?vue&type=template&id=7036ed76"
import script from "./ScrollingPage.vue?vue&type=script&lang=js"
export * from "./ScrollingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__